import { render, staticRenderFns } from "./Policydetail.vue?vue&type=template&id=40af8e32"
import script from "./Policydetail.vue?vue&type=script&lang=js"
export * from "./Policydetail.vue?vue&type=script&lang=js"
import style0 from "./Policydetail.vue?vue&type=style&index=0&id=40af8e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports